// extracted by mini-css-extract-plugin
export default {"tooltip":"qIR94d","content":"GysGrC"};